module.exports = __webpack_public_path__ + "img/close.4622e142.svg";